import React from 'react';

export default function empty() {
  return (
    <svg
      width="121"
      height="78"
      viewBox="0 0 121 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip-empty)">
        <path
          d="M60.8036 77.3242C93.9407 77.3242 120.804 71.448 120.804 64.1992C120.804 56.9505 93.9407 51.0742 60.8036 51.0742C27.6665 51.0742 0.803589 56.9505 0.803589 64.1992C0.803589 71.448 27.6665 77.3242 60.8036 77.3242Z"
          fill="#E0F1F3"
        />
        <path
          d="M84.4801 4.9468L84.5022 4.98235L84.5299 5.01373L103.429 26.4382V43.0742H18.1786V26.4401L37.0773 5.01182L37.1049 4.98056L37.1269 4.94517C37.9788 3.57557 39.1714 2.82422 40.353 2.82422H81.2542C82.4357 2.82422 83.6283 3.57546 84.4801 4.9468Z"
          fill="white"
          stroke="#5E6F72"
        />
        <path
          d="M79.328 32.1948C79.328 30.7898 79.7637 29.5245 80.4475 28.621C81.1311 27.7177 82.0391 27.2001 83.0038 27.1992H103.429V60.7061C103.429 62.5962 102.84 64.2983 101.911 65.5173C100.983 66.736 99.7356 67.4492 98.3973 67.4492H23.2098C21.8716 67.4492 20.6247 66.7357 19.6958 65.5167C18.7668 64.2974 18.1786 62.5952 18.1786 60.7061V27.1992H38.6036C39.5685 27.1992 40.4764 27.7157 41.1598 28.6177C41.8435 29.5199 42.2792 30.7842 42.2792 32.1892V32.2305C42.2792 35.3883 44.2751 38.1698 46.9736 38.1698H74.6336C75.977 38.1698 77.1612 37.4557 77.9936 36.372C78.8258 35.2884 79.328 33.8138 79.328 32.208V32.1948Z"
          fill="#B0DAE0"
          stroke="#5E6F72"
        />
      </g>
      <defs>
        <clipPath id="clip-empty">
          <rect width="120" height="76.875" fill="white" transform="translate(0.803589 0.449219)" />
        </clipPath>
      </defs>
    </svg>
  );
}
